(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.stacktrace
   * @description
   *
   */
  angular
    .module('utils.stacktrace', [
      'ui.router'
    ]);
}());
